import axiosPost from "../axiosPost";

export const zonaGet = async ({
    gateZonaId = null
}, credentials) => {
    const body = {
        service: "GateZonaGet",
        params: {
            merchantId: credentials.merchantId,
            gateZonaId,
        },
    };

    return await axiosPost(body, credentials);
};
